var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    { attrs: { disabled: _vm.disabled, title: "Level Tiles" } },
    [
      _c("r-level-track-level-field-tiles-view", {
        attrs: { model: _vm.value },
        on: {
          "update:model": function ($event) {
            _vm.value = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }